export var NOT_FOUND_HOUSE = 'NOT_FOUND_HOUSE';
export var GEOCODE_FIRST_RESULT = 1;
export var CHECK_ADDRESS_ACTIONS = 'CheckAddress';
export var CONNECTION_STATUS = {
  HasConnectionOnAddress: 'HasConnectionOnAddress',
  HasTicketOnAddress: 'HasTicketOnAddress',
  IsAvailable: 'IsAvailable',
  IsNotAvailable: 'IsNotAvailable',
  IsHighSpeedAvailable: 'IsHighSpeedAvailable'
};
export var AVAILABLE_STATUSES = [CONNECTION_STATUS.IsAvailable, CONNECTION_STATUS.IsHighSpeedAvailable, CONNECTION_STATUS.HasConnectionOnAddress, CONNECTION_STATUS.HasTicketOnAddress];